import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact', 'Support'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-91" data-mp="3ggk90wy2pg0l">
      <div className="mx-auto max-w-5xl text-center" data-id="element-92" data-mp="32oe0nx15wdbp">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-93" data-mp="32lrm3dfusxjz">
          PILATES READY™
        </p>
        <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-94" data-mp="3ufa4k858v7mu">
          EDULABS Professional Series 2026
        </p>
        <nav aria-label="Footer" data-id="element-95" data-mp="37fpyt5yq9xf">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-96" data-mp="36d1st00yll7">
            {links.map(link => <li key={link} data-id="element-97" data-mp="3qc44ji8q6cot">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-98" data-mp="3qf9raqtvt2hd">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-99" data-mp="3labovo69tsmo">
          © 2026 PILATES READY™. All rights reserved.
        </p>
      </div>
    </footer>;
}